'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hide = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _grid = require('@rebass/grid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withHidden = function withHidden(Component) {
  return function (_ref) {
    var xs = _ref.xs,
        sm = _ref.sm,
        md = _ref.md,
        lg = _ref.lg,
        xl = _ref.xl,
        xsmall = _ref.xsmall,
        small = _ref.small,
        medium = _ref.medium,
        large = _ref.large,
        xlarge = _ref.xlarge,
        display = _ref.display,
        props = _objectWithoutProperties(_ref, ['xs', 'sm', 'md', 'lg', 'xl', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'display']);

    var Hidden = _react2.default.createElement(Component, _extends({}, props, {
      display: display || [xs || xsmall, sm || small, md || medium, lg || large, xl || xlarge].map(function (n) {
        return n ? 'none' : 'block';
      })
    }));
    return Hidden;
  };
};

var Hide = exports.Hide = withHidden((0, _components2.default)({
  extend: _grid.Box
}, 'display'));

Hide.displayName = 'Hide';

exports.default = Hide;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rebass/dist/Hide.js
// module id = 133
// module chunks = 4